import React from 'react';
import parse from 'html-react-parser';
import styles from './SearchHighlight.module.scss';

const escapeRegex = (s) => s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
const normalizeSearchTerm = (search) => {
    const term = search?.trim();
    return term ? term : null;
};

/** Highlights search term in plain text. Returns React elements. */
export function highlightText(text, search) {
    if (!text || typeof text !== 'string') return text;
    const term = normalizeSearchTerm(search);
    if (!term) return text;

    const termLower = term.toLowerCase();
    const re = new RegExp(`(${escapeRegex(term)})`, 'gi');
    return text.split(re).map((part, i) =>
        part.toLowerCase() === termLower ? (
            <mark key={i} className={styles.highlight}>{part}</mark>
        ) : (
            <React.Fragment key={i}>{part}</React.Fragment>
        )
    );
}

/** Parses HTML and highlights search in text nodes. Returns React elements. */
export function highlightHtml(html, search) {
    if (!html || typeof html !== 'string') return null;
    const term = normalizeSearchTerm(search);
    if (!term) return parse(html);

    return parse(html, {
        replace: (node) => {
            if (node.type === 'text' && node.data) {
                const content = highlightText(node.data, term);
                return Array.isArray(content) ? <>{content}</> : content;
            }
        },
    });
}

export default function SearchHighlight({ text, search, className = '', as: Tag = 'span' }) {
    if (!text) return null;
    return <Tag className={className}>{highlightText(text, search)}</Tag>;
}
